import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';

const imgStyles = {
  margin: '1em 0',
  maxHeight: 150,
  float: 'right'
};

class Testimonals extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Grid style={{ marginTop: '2em' }}>
        <hr />
        <Row>
          <Col sm={6}>
            <Row>
              <Col xs={12}>
                <Col xs={4} style={{ paddingRight: 0, float: 'right' }}>
                  <img
                    src="/public/images/testimonial-ie-square.jpg"
                    alt="Isabella Eriksen, 26. maj 2015"
                    className="img-circle img-responsive"
                    style={imgStyles}
                  />
                </Col>
                <blockquote style={{ fontSize: '100%' }}>
                  <p>
                    Tak for at have hjulpet mig med, at finde lige præcis den
                    lejlighed som jeg længe har ønsket. Ved hjælp fra mit
                    abonnement på Boligninja, har hele processen været nem og
                    simpel, og jeg vil helt bestemt benytte mig af, samt
                    anbefale Boligninja til venner og bekendte, hvis jeg igen
                    står og skal igennem lignende process.
                  </p>
                  <footer>Isabella Eriksen</footer>
                </blockquote>
              </Col>
            </Row>
          </Col>
          <Col sm={6}>
            <Row>
              <Col xs={12}>
                <Col
                  xs={4}
                  style={{
                    paddingRight: 0,
                    float: 'right',
                    textAlign: 'right'
                  }}
                >
                  <img
                    src="/public/images/testimonial-ds-square.jpg"
                    alt="Daniel Spirin, 29. marts 2015"
                    className="img-circle img-responsive"
                    style={imgStyles}
                  />
                </Col>
                <blockquote style={{ fontSize: '100%' }}>
                  <p>
                    Tak for at have hjulpet os med at have fundet lige det hjem
                    som vi og vores to små drenge skal bo i. Boligninja.dk var
                    fra starten nem og simpel at finde ud af og man har et
                    fantastisk overblik på hjemmesiden og side designet ser cool
                    ud og er simpelt at navigere. Vi vil helt sikkert anbefale
                    Boligninja.dk til venner og bekendte.
                  </p>
                  <footer>Daniel Spirin</footer>
                </blockquote>
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Testimonals;
